module.exports = __webpack_public_path__ + "static/media/planet.0f8ada1a.png";